import { render, staticRenderFns } from "./Check1.vue?vue&type=template&id=756c5b80&scoped=true"
import script from "./Check1.vue?vue&type=script&lang=js"
export * from "./Check1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756c5b80",
  null
  
)

export default component.exports